export default __webpack_public_path__ + "static/media/One Drop - New Logo.f728fbe5.png";